import React from 'react';

function YTab(props) {
	const selected = props.selected || 0;
	const add_classes = props.add_classes || [];
	const unselected_class = props.unselected_class || 'ad_ytab_item';
	const selected_class = props.selected_class || 'ad_ytab_item_selected';

	var elements = [];
	for (var i = 0; i < props.items.length; i++) {
		const item = props.items[i];
		if (i === selected) {
			const classes = [...add_classes, selected_class].join(" ");
			elements.push(
				<div key={i} className={classes}>{item}</div>
			);
		} else {
			const classes = [...add_classes, unselected_class].join(" ");
			const onSelect = ((i) => () => {
				if (props.onSelect) props.onSelect(i);
			})(i);
			elements.push(
				<div key={i} role="button" tabIndex="0" onClick={onSelect} onKeyPress={onSelect} className={classes}>
					{item}
				</div>
			);
		}
	}

	return (
		<div>
			{elements}
		</div>
	);
}

export default YTab;



// WEBPACK FOOTER //
// ./src/c/YTab.js